import {
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { StaffMember } from '../../models/app.models';
import { StaffMemberService } from '../../services/staff-member.service';

@Component({
  selector: 'app-team',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './team.component.html',
  styleUrl: './team.component.css'
})
export class TeamComponent implements OnInit {
  staffMembers: StaffMember[] = [];

  loading = true;
  loadError = false;

  constructor(
    private readonly staffMemberService: StaffMemberService,
    private readonly changeDetector: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.loadStaffMembers();
  }

  private loadStaffMembers(): void {
    this.loading = true;
    this.loadError = false;

    this.staffMemberService
      .getStaffMembers()
      .subscribe({
        next: members => {
          this.staffMembers = members;

          this.loading = false;

          this.changeDetector.markForCheck();
        },

        error: error => {
          console.error(
            'Unable to load staff members:',
            error
          );

          this.loading = false;
          this.loadError = true;

          this.changeDetector.markForCheck();
        }
      });
  }
  isPlaceholderImage(imageUrl: string | null | undefined): boolean {
  if (!imageUrl) {
    return false;
  }

  const cleanUrl = imageUrl
    .split('?')[0]
    .split('#')[0]
    .replace(/\/+$/, '');

  return cleanUrl.endsWith('/api/media/1');
}
}